export default "__VITE_ASSET__RzIdz5Do__"